import script from "./franchise.vue?vue&type=script&setup=true&lang=ts"
export * from "./franchise.vue?vue&type=script&setup=true&lang=ts"

import "./franchise.vue?vue&type=style&index=0&id=62fc13a6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62fc13a6"]])

export default __exports__